export default __webpack_public_path__ + "4f8542f3ecd8408babb41a535f060861.svg";